import React from "react";
import { CSS } from "@dnd-kit/utilities";
import {
	restrictToParentElement,
	restrictToVerticalAxis,
} from "@dnd-kit/modifiers";
import { useSortable } from "@dnd-kit/sortable";
import { Container } from "./components";
import { Sortable } from "./Sortable";
import styles from "./components/Container/Container.module.css";
import { AddRounded } from "@material-ui/icons";
import { FormHelperText } from "@material-ui/core";

export default function DroppableContainer({
	children,
	disabled,
	id,
	items,
	style,
	handle,
	renderItem,
	getItemStyles,
	header,
	onAddItem,
	canAddItem = true,
	onItemsReorder,
	onItemRemove,
	expanded,
	isPreviewMode,
	resources,
	isDragOverlay = false,
	hasValidationErrors = false, 
	validationErrorMessage = '',
	...props
}) {
	const {
		active,
		attributes,
		isDragging,
		listeners,
		over,
		setNodeRef,
		transition,
		transform,
	} = useSortable({
		id,
		data: {
			type: "container",
			children: items,
		},
	});

	const isOverContainer = over
		? (id === over.id && active?.data.current?.type !== "container") ||
		  items.includes(over.id)
		: false;

	return (
		<div style={{position: 'relative', paddingBottom: '18px'}}>
			<Container
				ref={disabled ? undefined : setNodeRef}
				style={{
					...style,
					transition,
					transform: CSS.Translate.toString(transform),
					opacity: isDragging ? 0.5 : undefined,
					marginBottom: 0,
				}}
				hover={isOverContainer}
				handleProps={{
					...attributes,
					...listeners,
				}}
				header={header}
				expanded={expanded}
				isPreviewMode={isPreviewMode}
				resources={resources}
				containerId={id}
				hasValidationErrors={hasValidationErrors}
				{...props}
				isDragOverlay={isDragOverlay}
			>
				<Sortable
					items={items}
					renderItem={renderItem}
					getItemStyles={getItemStyles}
					removable
					handle
					modifiers={[restrictToVerticalAxis, restrictToParentElement]}
					onItemsReorder={onItemsReorder}
					onItemRemove={onItemRemove}
					isPreviewMode={isPreviewMode}
					resources={resources}
				/>
				{!isPreviewMode && (
					<button
						className={styles.AddButton}
						onClick={() => onAddItem(id)}
						disabled={!canAddItem}
					>
						<AddRounded /> {resources["AddSegmentItem"]}
					</button>
				)}
			</Container>
			{(hasValidationErrors && validationErrorMessage) && 
			<FormHelperText 
				error 
				style={{
					position: 'absolute', 
					bottom: '0px', 
					left: '14px'
				}}
			>
				{validationErrorMessage}
			</FormHelperText>
			}
		</div>
	);
}
